var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/ui/components/compose-button.tsx";
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { compose } from 'soapbox/actions/compose';
import { Button } from 'soapbox/components/ui';
const ComposeButton = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const onOpenCompose = useCallback(() => {
    dispatch(compose());
    history.push('/statuses/compose');
  }, [dispatch, history]);
  return /*#__PURE__*/React.createElement("div", {
    className: "mt-4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Button, {
    icon: require('@tabler/icons/pencil-plus.svg'),
    block: true,
    size: "lg",
    onClick: onOpenCompose,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("span", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "navigation.compose",
    defaultMessage: "Compose",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 15
    }
  }))));
};
export default ComposeButton;